import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { DataPlaneApiPort } from './ports/data-plane-api.port';
import { AdessoDataPlaneApiAdapter } from './adapters/adesso-data-plane-api.adapter';

/**
 * Provides DataPlaneApiPort backed by the adesso-connector-api adapter.
 */
export function provideDataPlaneApi(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: DataPlaneApiPort, useClass: AdessoDataPlaneApiAdapter }
  ]);
}
